import { render, staticRenderFns } from "./AMAfaGraffiti.vue?vue&type=template&id=34709dbc&scoped=true"
import script from "./AMAfaGraffiti.vue?vue&type=script&lang=ts"
export * from "./AMAfaGraffiti.vue?vue&type=script&lang=ts"
import style0 from "./AMAfaGraffiti.vue?vue&type=style&index=0&id=34709dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34709dbc",
  null
  
)

export default component.exports